/* ==================================================
   REVAINE — GLOBAL PREMIUM SCROLL REVEAL
   Soft Lift + Focus Reveal
   Standalone animation system
   Protects fixed/sticky navigation
================================================== */

(function () {
  'use strict';

  if (window.__revaineMotionV3Loaded) return;
  window.__revaineMotionV3Loaded = true;

  function initRevaineMotion() {
    /* Do not animate inside Shopify's theme editor */
    if (window.Shopify && window.Shopify.designMode) return;

    /* Respect accessibility preferences */
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    if (!('IntersectionObserver' in window)) return;

    var main = document.querySelector(
      '#MainContent, main#main, main, [role="main"]'
    );

    if (!main) return;

    /* ----------------------------------------------
       1. INJECT ANIMATION CSS
       Uses a new style ID to avoid old CSS conflicts
    ---------------------------------------------- */

    var style = document.getElementById(
      'revaine-global-motion-v3-styles'
    );

    if (!style) {
      style = document.createElement('style');
      style.id = 'revaine-global-motion-v3-styles';
      document.head.appendChild(style);
    }

    style.textContent = `
      .rv-motion-reveal {
        opacity: 0;
        transform: translate3d(0, 20px, 0);
        filter: blur(2px);

        transition:
          opacity 700ms cubic-bezier(.22, 1, .36, 1),
          transform 850ms cubic-bezier(.22, 1, .36, 1),
          filter 700ms cubic-bezier(.22, 1, .36, 1);

        backface-visibility: hidden;
      }

      .rv-motion-reveal.rv-motion-visible {
        opacity: 1;
        transform: translate3d(0, 0, 0);
        filter: blur(0);
      }

      @media (max-width: 749px) {
        .rv-motion-reveal {
          transform: translate3d(0, 12px, 0);
          filter: blur(1.5px);

          transition:
            opacity 600ms cubic-bezier(.22, 1, .36, 1),
            transform 700ms cubic-bezier(.22, 1, .36, 1),
            filter 600ms cubic-bezier(.22, 1, .36, 1);
        }

        .rv-motion-reveal.rv-motion-visible {
          transform: translate3d(0, 0, 0);
          filter: blur(0);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .rv-motion-reveal,
        .rv-motion-reveal.rv-motion-visible {
          opacity: 1 !important;
          transform: none !important;
          filter: none !important;
          transition: none !important;
        }
      }
    `;

    /* ----------------------------------------------
       2. FIND SECTIONS TO ANIMATE
    ---------------------------------------------- */

    var sections = Array.from(
      main.querySelectorAll('.shopify-section')
    );

    if (!sections.length) {
      sections = Array.from(main.children);
    }

    var targets = [];

    sections.forEach(function (section) {
      if (!section || section.nodeType !== 1) return;

      /* Skip navigation and footer elements */
      if (
        section.matches(
          'header, footer, nav, [role="navigation"], ' +
          '[data-rv-mobile-bottom-nav], [data-mobile-nav]'
        )
      ) {
        return;
      }

      /* Skip any section containing the mobile navbar */
      if (
        section.querySelector(
          '[data-rv-mobile-bottom-nav], [data-mobile-nav]'
        )
      ) {
        return;
      }

      /*
        Never animate a section containing fixed or sticky
        elements. This helps protect floating and bottom navs.
      */
      var descendants = section.querySelectorAll('*');
      var hasPositionedUI = false;

      for (var i = 0; i < descendants.length; i++) {
        var element = descendants[i];
        var position = window.getComputedStyle(element).position;

        if (position === 'fixed' || position === 'sticky') {
          hasPositionedUI = true;
          break;
        }
      }

      if (hasPositionedUI) return;

      /* Avoid adding the animation twice */
      if (section.classList.contains('rv-motion-reveal')) {
        targets.push(section);
        return;
      }

      section.classList.add('rv-motion-reveal');
      targets.push(section);
    });

    /* ----------------------------------------------
       3. REVEAL SECTIONS WHEN THEY ENTER THE VIEW
    ---------------------------------------------- */

    var observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('rv-motion-visible');

          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.03,
        rootMargin: '0px 0px -30px 0px'
      }
    );

    targets.forEach(function (section) {
      observer.observe(section);
    });

    /* ----------------------------------------------
       4. FAIL-SAFE
       If initialization fails, keep page content visible
    ---------------------------------------------- */

    window.addEventListener(
      'pageshow',
      function () {
        if (
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
        ) {
          targets.forEach(function (section) {
            section.classList.add('rv-motion-visible');
          });
        }
      },
      { once: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initRevaineMotion,
      { once: true }
    );
  } else {
    initRevaineMotion();
  }
})();